import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? '0', 10);
  }

  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : '';
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
    this.ensureCartBubbleIsCorrect();
    this.verifyCartCount();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageShow = (event) => {
    if (event.persisted) {
      this.ensureCartBubbleIsCorrect();
      this.verifyCartCount();
    }
  };

  onCartUpdate = async (event) => {
    const itemCount = event.detail.data?.itemCount ?? 0;
    const comingFromProductForm = event.detail.data?.source === 'product-form-component';
    await this.renderCartBubble(itemCount, comingFromProductForm);
    this.verifyCartCount();
  };

  renderCartBubble = async (itemCount, comingFromProductForm, animate = true) => {
    this.refs.cartBubbleCount.classList.toggle('hidden', itemCount === 0);
    this.refs.cartBubble.classList.toggle('visually-hidden', itemCount === 0);
    this.currentCartCount = comingFromProductForm ? this.currentCartCount + itemCount : itemCount;
    this.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({ value: String(this.currentCartCount), timestamp: Date.now() })
    );

    if (!(!animate || itemCount === 0)) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
      this.refs.cartBubble.classList.add('cart-bubble--animating');
      await onAnimationEnd(this.refs.cartBubbleText);
      this.refs.cartBubble.classList.remove('cart-bubble--animating');
    }
  };

  ensureCartBubbleIsCorrect = () => {
    if (!this.refs.cartBubbleCount) return;
    const sessionStorageCount = sessionStorage.getItem('cart-count');
    if (sessionStorageCount === null) return;
    const visibleCount = this.refs.cartBubbleCount.textContent;
    try {
      const { value, timestamp } = JSON.parse(sessionStorageCount);
      if (value === visibleCount) return;
      if (Date.now() - timestamp < 10000) {
        const count = parseInt(value, 10);
        count >= 0 && this.renderCartBubble(count, false, false);
      }
    } catch {}
  };

  // Holt die tatsächliche Warenkorb-Anzahl vom Server und korrigiert die
  // Anzeige, falls sie (z. B. durch die Seiten-Morph-Navigation) nicht mehr
  // mit dem echten Warenkorb übereinstimmt.
  verifyCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!this.isConnected || !this.refs.cartBubbleCount) return;
      if (cart.item_count !== this.currentCartCount) {
        this.renderCartBubble(cart.item_count, false, false);
      }
    } catch {
      // Netzwerkfehler ignorieren, Anzeige bleibt unverändert
    }
  };
}

customElements.get('cart-icon') || customElements.define('cart-icon', CartIcon);